var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _line, _line2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.72 33.85C25.54 34.03 25.22 34.06 25.01 33.85C24.83 33.67 24.8 33.35 25.01 33.14L28.4 29.75L26.99 28.34L23.6 31.73C23.41 31.93 23.09 31.92 22.89 31.73C22.68 31.52 22.71 31.2 22.89 31.02L26.28 27.63L24.87 26.22L21.48 29.61C21.3 29.79 20.98 29.82 20.77 29.61C20.58 29.42 20.58 29.1 20.77 28.9L24.16 25.51L22.74 24.1L19.35 27.49C19.17 27.67 18.85 27.7 18.64 27.49C18.45 27.29 18.45 26.98 18.64 26.78L23.02 22.4L24.89 24.26C25.84 25.21 27.48 25.2 28.43 24.26C29.41 23.28 29.41 21.7 28.43 20.72L26.57 18.86L26.85 18.58C27.63 17.8 28.9 17.8 29.68 18.58L33.92 22.82C34.7 23.6 34.7 24.87 33.92 25.65L25.72 33.85Z",
    fill: "#1565D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.72 33.85C25.54 34.03 25.22 34.06 25.01 33.85C24.83 33.67 24.8 33.35 25.01 33.14L28.4 29.75L26.99 28.34L23.6 31.73C23.41 31.93 23.09 31.92 22.89 31.73C22.68 31.52 22.71 31.2 22.89 31.02L26.28 27.63L24.87 26.22L21.48 29.61C21.3 29.79 20.98 29.82 20.77 29.61C20.58 29.42 20.58 29.1 20.77 28.9L24.16 25.51L22.74 24.1L19.35 27.49C19.17 27.67 18.85 27.7 18.64 27.49C18.45 27.29 18.45 26.98 18.64 26.78L23.02 22.4L24.89 24.26C25.84 25.21 27.48 25.2 28.43 24.26C29.41 23.28 29.41 21.7 28.43 20.72L26.57 18.86L26.85 18.58C27.63 17.8 28.9 17.8 29.68 18.58L33.92 22.82C34.7 23.6 34.7 24.87 33.92 25.65L25.72 33.85ZM35.33 27.07C36.89 25.51 36.89 22.98 35.33 21.41L31.09 17.17C29.53 15.61 27 15.61 25.43 17.17L25.15 17.45L24.87 17.17C23.31 15.61 20.78 15.61 19.21 17.17L15.67 20.71C14.25 22.13 14.12 24.34 15.27 25.9L16.72 24.45C16.33 23.7 16.46 22.75 17.09 22.12L20.63 18.58C21.41 17.8 22.68 17.8 23.46 18.58L27.02 22.14C27.2 22.32 27.23 22.64 27.02 22.85C26.81 23.06 26.49 23.03 26.31 22.85L23.02 19.57L17.22 25.36C16.24 26.33 16.24 27.92 17.22 28.9C17.61 29.29 18.11 29.53 18.64 29.6C18.71 30.12 18.94 30.62 19.34 31.02C19.74 31.42 20.24 31.65 20.76 31.72C20.83 32.24 21.06 32.74 21.46 33.14C21.86 33.54 22.36 33.77 22.88 33.84C22.95 34.38 23.19 34.87 23.58 35.26C24.05 35.73 24.68 35.99 25.35 35.99C26.02 35.99 26.65 35.73 27.12 35.26L35.33 27.07Z",
    fill: "#1565D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 38L50 -8.74228e-08L52 0L52 38C51.5 38.5 51.5 38.5 51.5 38.5C51.5 38.5 50.3905 38 50 38Z",
    fill: "#1565D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.641 38.3781L39.4493 51.1986C39.098 51.4952 38.4999 51.9999 38.4999 51.9999C38.4999 51.9999 37.6079 50.5577 37.5 50.0001L50.1917 36.9999L51.641 38.3781Z",
    fill: "#1565D8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37115e-8,
    x2: 0.999998,
    y2: 52,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 1,
    y2: 1,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 51L2 51",
    stroke: "#1565D8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTeam);
export default __webpack_public_path__ + "static/media/other-team.b669bdf5d3ef10c8b47b166ea5ddad10.svg";
export { ForwardRef as ReactComponent };